// ============================================================
// 全コンポーネント共通の定数・ユーティリティ
// ============================================================

/** 運営管理者メールアドレス（1箇所で管理） */
export const SYSTEM_ADMIN = "carewave0614@gmail.com";

/** キオスク打刻用トークン生成（5分ごとに更新） */
export function generateKioskToken() {
  return btoa(JSON.stringify({ t: Date.now() }));
}

/** デバイス識別ID（localStorage永続） */
export function getDeviceId() {
  let id = localStorage.getItem("miyabi_device_id");
  if (!id) {
    id = "device_" + Math.random().toString(36).substr(2, 12) + "_" + Date.now();
    localStorage.setItem("miyabi_device_id", id);
  }
  return id;
}
